import React from 'react';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Hooks
import { useCoachingV2RouteHandler } from 'Dashboard/components/CoachingPageV2/use-coaching-v2-route-handler';

// Components
import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from 'Wpds/components/page-layout';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import ReviewsBlocker from './partials/ReviewsBlocker';

// Styles
import './ThreeSixtyFreePlanBlockerPage.scss';

type Props = {
  withHeader?: boolean;
};

const ThreeSixtyFreePlanBlockerPage = ({ withHeader = true }: Props) => {
  const { handleCoachingV2Redirect } = useCoachingV2RouteHandler();

  const handleDismissClick = () => {
    handleCoachingV2Redirect({ pathname: PageUrls.COACHING_360 });
  };

  const baseClassName = 'ThreeSixtyFreePlanBlockerPage';

  return (
    <WpPageLayout width="container" className={baseClassName}>
      {withHeader && (
        <WpPageHeader>
          <WpPageTitle
            title="360 Feedback"
            buttonsOnMobile="inline"
            buttonsContainer={
              <WpButton variant="tertiary" onClick={handleDismissClick}>
                <WpIcon name="times" />
              </WpButton>
            }
          />
        </WpPageHeader>
      )}
      <WpPageBody>
        <ReviewsBlocker />
      </WpPageBody>
    </WpPageLayout>
  );
};

export default ThreeSixtyFreePlanBlockerPage;
